import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';

export const selectAuthenticatedAndLicensed = (
  s: GlobalStateMergedState,
): boolean => s.loginStatus === 'AUTHENTICATED' && s.license.state === 'VALID';
